import React, { useCallback } from 'react';
import { FormGroup, Intent, Classes } from '@blueprintjs/core';
import classNames from 'classnames';

import { CellType } from '@/constants';
import { AnalyticCategorySuggestField } from '@/components/AnalyticCategory/AnalyticCategorySuggestField';
import { CellRendererProps } from './types';

/**
 * Analytic-category (expense category) list field cell. Renders a unified
 * autocomplete picker inside an editable data table and writes the picked
 * dimension id to the `analytic_dimension_id` column of the row.
 */
export function CategoryListFieldCell({
  column: { id },
  row: { index, original },
  payload: { analyticCategories, updateData, errors },
}: CellRendererProps) {
  const handleCategorySelected = useCallback(
    (dim: { id: number }) => {
      updateData(index, 'analytic_dimension_id', dim.id);
    },
    [updateData, index],
  );

  const error = errors?.[index]?.[id];
  return (
    <FormGroup
      intent={error ? Intent.DANGER : undefined}
      className={classNames(
        'form-group--select-list',
        'form-group--contacts-list',
        Classes.FILL,
      )}
    >
      <AnalyticCategorySuggestField
        categories={analyticCategories || []}
        onCategorySelected={handleCategorySelected}
        selectedCategoryId={original?.analytic_dimension_id}
      />
    </FormGroup>
  );
}

CategoryListFieldCell.cellType = CellType.Field;
